import { defineStore } from "pinia";
import { ref } from "vue";

export const useLocationStore = defineStore(
  "Location",
  () => {
    const location = ref(null);

    // actions
    const setLocation = (locationData) => {
      location.value = locationData;
    };

    return { location, setLocation };
  },
  {
    persist: true, //salva automaticamente no localstora
  }
);
